import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import edesignconstant from '../../../../../assets/edesignconfig.json';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-document-size-limitation',
    templateUrl: './document-size-limitation.component.html',
    styleUrls: ['./document-size-limitation.component.scss'],
    standalone: false
})
export class DocumentSizeLimitationComponent {
  fileUploadThreshold = edesignconstant.FileUploadThreshold;
  @Input() total: number;
  @Input() current: number;
}
